import apiClient from './client';
import { API_ENDPOINTS } from './config';

export const supportApi = {
  ask: async (message) => {
    const response = await apiClient.post(API_ENDPOINTS.SUPPORT.ASK, { message });
    return response;
  },
  escalate: async (payload) => {
    const response = await apiClient.post(API_ENDPOINTS.SUPPORT.ESCALATE, payload);
    return response;
  },
  getUserTickets: async (userId, limit = 50, offset = 0) => {
    const response = await apiClient.get(API_ENDPOINTS.SUPPORT.USER_TICKETS(userId), {
      params: { limit, offset }
    });
    return response;
  }
};

export default supportApi;
